var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHeroiconsTicket(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.3125 3.75V4.21875M10.3125 6.09375V6.5625M10.3125 8.4375V8.90625M10.3125 10.7812V11.25M4.6875 7.96875H7.96875M4.6875 9.375H6.5625M2.10938 3.28125C1.72125 3.28125 1.40625 3.59625 1.40625 3.98438V5.87563C1.69172 6.03998 1.92883 6.27667 2.0937 6.56184C2.25857 6.84701 2.34538 7.1706 2.34538 7.5C2.34538 7.8294 2.25857 8.15299 2.0937 8.43816C1.92883 8.72333 1.69172 8.96002 1.40625 9.12437V11.0156C1.40625 11.4037 1.72125 11.7188 2.10938 11.7188H12.8906C13.2787 11.7188 13.5938 11.4037 13.5938 11.0156V9.12437C13.3083 8.96002 13.0712 8.72333 12.9063 8.43816C12.7414 8.15299 12.6546 7.8294 12.6546 7.5C12.6546 7.1706 12.7414 6.84701 12.9063 6.56184C13.0712 6.27667 13.3083 6.03998 13.5938 5.87563V3.98438C13.5938 3.59625 13.2787 3.28125 12.8906 3.28125H2.10938Z",
    stroke: "#12234F",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeroiconsTicket);
export default __webpack_public_path__ + "static/media/heroicons_ticket.72bbe3177e3cf2e8448785e80d2bdd9a.svg";
export { ForwardRef as ReactComponent };